import { useCallback, useState } from 'react';

// AddMonitorBar re-applies a suggestion only when `seq` changes, so picking the same example twice still refills it.
const usePromptSuggestion = () => {
    const [suggestion, setSuggestion] = useState(null);
    const pickSuggestion = useCallback(text => setSuggestion(prev => ({ text, seq: (prev?.seq ?? 0) + 1 })), []);
    // Without this the bar remounting on the zero->one monitor swap would re-apply the prompt that was just submitted.
    const clearSuggestion = useCallback(() => setSuggestion(null), []);
    return { suggestion, pickSuggestion, clearSuggestion };
};

export default usePromptSuggestion;
